import type { ValueOf } from "@packall/core";

/** What to do about an output file that already exists. */
export const ForceMode = {
	/** Ask, once per colliding file. The default. */
	Prompt: "prompt",
	/** Replace everything. */
	All: "all",
	/** Refuse, and exit non-zero. */
	None: "none",
} as const;

export type ForceMode = ValueOf<typeof ForceMode>;
